export default __webpack_public_path__ + "static/ai_feedback-f3d71f626a69e0266199690c39434bdf.mp4";